class InkoraHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.inkora-hero-slide')];
    this.dots = [...this.querySelectorAll('.inkora-hero-slideshow__dot')];
    this.prevButton = this.querySelector('.inkora-hero-slideshow__arrow--prev');
    this.nextButton = this.querySelector('.inkora-hero-slideshow__arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 6000;

    if (this.slides.length < 2) return;

    this.prevButton?.addEventListener('click', () => {
      this.goTo(this.current - 1);
      this.restartAutoplay();
    });
    this.nextButton?.addEventListener('click', () => {
      this.goTo(this.current + 1);
      this.restartAutoplay();
    });
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.startAutoplay();
  }

  goTo(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;
    this.slides.forEach((slide, i) => {
      const isActive = i === this.current;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
  }

  startAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this._timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  stopAutoplay() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

customElements.define('inkora-hero-slideshow', InkoraHeroSlideshow);
